import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondQueryKey } from "../bond.keys";
import { SuretyBond } from "./types";

export const useFetchBond = (id: string, enabled: boolean = true) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondQueryKey(id),
		queryFn: async () => await get<SuretyBond>(`/v2/surety/bonds/${id}`),
		retry: false,
		enabled,
	});

	return { bond: data, bondError: error, bondLoading: isLoading };
};
